const getThresholdAnalogComputedSensorFromSensorMap = (thresholdData, deviceListSensorMap) => {
  const { macAddress, channelGroupTypeId, channelGroupIndex } = thresholdData;
  if (Object.keys(deviceListSensorMap).length === 0) {
    return null;
  }
  const deviceSensorList = deviceListSensorMap[macAddress];
  if (!Array.isArray(deviceSensorList) || typeof deviceSensorList === 'undefined') {
    return null;
  }
  return deviceSensorList.find(
    (sensor) => sensor.conversion != null
          && sensor.channelGroupTypeId === channelGroupTypeId
          && sensor.channelGroupIndex === channelGroupIndex,
  );
};

const getAnalogComputedUnit = (thresholdData, deviceListSensorMap) => {
  const analogComputedSensor = getThresholdAnalogComputedSensorFromSensorMap(
    thresholdData, deviceListSensorMap,
  );
  if (!analogComputedSensor) {
    return 'V';
  }
  return analogComputedSensor.conversion.unit
    ? analogComputedSensor.conversion.unit
    : 'V';
};

export { getAnalogComputedUnit, getThresholdAnalogComputedSensorFromSensorMap };
